import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Tag from '../../Common/Tag/WeddingPhotoItem'
import { Flex } from 'hljd'

@inject('decorationStore')
@observer
export default class extends Component {
  componentDidMount() {
    this.props.decorationStore.getMealCasePropertyList({
      commodity_type: 1
    })
  }

  render() {
    const {
      casePropertyTagList,
      changeCaseProperty,
      currentCaseProperty
    } = this.props.decorationStore

    return (
      <Flex wrap>
        {casePropertyTagList.map(item => (
          <Tag
            key={item.id}
            {...item}
            active={currentCaseProperty}
            onChange={changeCaseProperty}
          />
        ))}
      </Flex>
    )
  }
}
